import { useCallback } from 'react';
import { AccountDisabledNotification } from 'src/components/common/AccountDisabledNotification';
import { AccountInactiveNotification } from 'src/components/common/AccountInactiveNotification';
import { ActivePosEntityProvider } from 'src/contexts/ActivePosEntityContext';
import { useAppContext } from 'src/contexts/AppContext';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { useContent } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { MobileDrawerProvider } from 'src/contexts/MobileDrawerContext';
import { MobilePurchasesSortAndFilterContextProvider } from 'src/contexts/MobileSortAndFilterContext/MobilePurchasesSortAndFilterContext';
import { usePurchaseDataContext } from 'src/contexts/PurchaseDataContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { globalMobileWrapper } from 'src/core/themes/themeContract.css';
import { Stack } from 'src/core/ui';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ActionOutboxEntityType,
  PurchaseClient,
  PurchaseOrderDetails,
} from 'src/WebApiController';

import { MainRoute } from '../../MainRoute';
import { EventFilterBar } from './components/EventFilterBar';
import { EventGroupedTiles } from './components/EventGroupedList';

export const PurchaseEventsMobile = () => {
  const routeTitle = useContent(ContentId.Purchases);
  const { isLoading, eventsTransformed } = useCatalogDataContext();
  const { activeAccountWebClientConfig } = useAppContext();

  const { onSetActivePurchaseOrderCallback } = usePurchaseDataContext();

  const getActivePosEntity = useCallback(
    async (purchaseId: number) => {
      const purchaseDetails = await new PurchaseClient(
        activeAccountWebClientConfig
      ).getPurchaseOrderByPurchaseOrderId(purchaseId, false);
      if (purchaseDetails) {
        return {
          posEntityId: purchaseDetails.id,
          posEntity: purchaseDetails,
          event: null,
          posEntityDisplayId: purchaseDetails.id.toString(),
        };
      }

      return {};
    },
    [activeAccountWebClientConfig]
  );

  if (isLoading) {
    return <PosSpinner />;
  }

  return (
    <ActivePosEntityProvider<PurchaseOrderDetails>
      entityType={ActionOutboxEntityType.Purchase}
      getActivePosEntity={getActivePosEntity}
      onSetActiveItemCompleteCallback={onSetActivePurchaseOrderCallback}
    >
      <MobilePurchasesSortAndFilterContextProvider>
        <DialogProvider>
          <MobileDrawerProvider>
            <LayoutContent
              mainRoute={MainRoute.Purchases}
              routeTitle={routeTitle}
            >
              <Stack
                direction="column"
                className={globalMobileWrapper}
                style={{ height: '100%', width: '100%' }}
              >
                <AccountDisabledNotification />
                <AccountInactiveNotification />
                <EventFilterBar />
                <EventGroupedTiles eventsTransformed={eventsTransformed} />
              </Stack>
            </LayoutContent>
          </MobileDrawerProvider>
        </DialogProvider>
      </MobilePurchasesSortAndFilterContextProvider>
    </ActivePosEntityProvider>
  );
};
